<template>
  <div class="article">
    <header>
      <p>
        Gestiona tus usuarios. Administradores, supervisores, teleoperadores y más.
        <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
      </p>

      <div>
        <span>
          <!-- <strong v-if="slotsInfo?.slot_type_billing === 'Postpago'">
            Total de slots: {{ slotsInfo?.slots_invoice }}</strong
          > -->
          <strong>
            Total de slots:
            {{ totalSlots }}
          </strong>
        </span>

        <a-divider type="vertical" class="divider" />

        <span> Slots utilizados: {{ slotsInfo?.slot_assigned }} </span>

        <a-divider type="vertical" class="divider" />

        <span>
          <a-popover
            v-model:open="openPopover"
            title="Slots disponibles"
            :overlayStyle="{ width: '235px' }"
          >
            <template #content>
              <span style="color: #595959">
                Los slots disponibles son la cantidad de usuarios que aún tienes para agregar. Por
                ejemplo, si tienes 10 slots disponibles, aún puedes agregar 10 usuarios más a tu
                equipo de trabajo.
              </span>

              <a-button
                v-if="isClientBeexcc"
                type="primary"
                style="width: 100%; margin-top: 16px"
                @click="
                  handleOpenBuyModal();
                  openPopover = false;
                "
              >
                Comprar slots
              </a-button>
            </template>

            <InfoCircleOutlined />
          </a-popover>
          Slots disponibles:
          <span v-if="slotsInfo?.slot_type_billing === 'Postpago'">{{ remainingSlots }}</span>
          <span v-else>{{ remainingPrepaidSlots }}</span>
        </span>
      </div>
    </header>

    <users-table-controls
      @update="handleSearch"
      @openBuySlotsModal="handleOpenBuyModal"
      :remainingSlots="`${
        slotsInfo?.slot_type_billing === 'Postpago' ? remainingSlots : remainingPrepaidSlots
      }`"
      :slotsInfo="slotsInfo"
    />

    <users-table
      class="table-users"
      @update="handleSearch"
      @openBuySlotsModal="handleOpenBuyModal"
      @created="fetchSlotsData"
    />
  </div>

  <BuySlotsModal
    v-if="openBuySlotsModal"
    v-model:open="openBuySlotsModal"
    :slotsInfo="slotsInfo"
    :neededSlots="neededSlots"
    :remainingSlots="`${
      slotsInfo?.slot_type_billing === 'Postpago' ? remainingSlots : remainingPrepaidSlots
    }`"
    @update="handleSearch"
  />
</template>

<script setup>
import { reactive, provide, watch, ref, computed } from "vue";
import { useStore } from "vuex";
import _ from "lodash";
import { message } from "ant-design-vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import UsersTableControls from "@/app/users/components/tables/UsersTableControls.vue";
import UsersTable from "@/app/users/components/tables/UsersTable.vue";
import SlotManager from "@/app/settings/services/slots/SlotManager";
import BuySlotsModal from "@/app/settings/components/modals/BuySlotsModal.vue";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/menu-usuario/equipo-de-trabajo/listado-usuarios/`;
const slotManager = new SlotManager();

const store = useStore();
const user = computed(() => store.getters["getDataUser"]);
const isClientBeexcc = computed(() => user.value?.is_beexcc);
const openPopover = ref(false);
const openBuySlotsModal = ref(false);

const formState = reactive({
  search: "",
  selectedProfile: 0,
});
const slotsInfo = ref();
const loading = ref(false);
provide("loadingTable", loading);

provide("formState", formState);

const fetchSlotsData = async () => {
  slotsInfo.value = await slotManager.getInfoSlots();
};

const remainingSlots = computed(
  // () => (slotsInfo.value?.slots_invoice ?? 0) - (slotsInfo.value?.slot_assigned ?? 0)
  () => remainingPrepaidSlots.value
);

const remainingPrepaidSlots = computed(
  () =>
    (slotsInfo.value?.slots_invoice ?? 0) -
    (slotsInfo.value?.slot_assigned ?? 0) -
    (slotsInfo.value?.slot_deleted ?? 0)
);

const totalSlots = computed(
  () => (slotsInfo.value?.slots_invoice ?? 0) - (slotsInfo.value?.slot_deleted ?? 0)
);

const neededSlots = ref(0);

const handleOpenBuyModal = (slots = 0) => {
  openBuySlotsModal.value = true;
  neededSlots.value = slots;
};

const handleSearch = async (pagination) => {
  loading.value = true;

  try {
    await store.dispatch("fetchAllFilterProfile", {
      search: formState.search,
      profile: formState.selectedProfile,
      pagination,
    });
    await fetchSlotsData();
  } catch (error) {
    message.error("No se pudo actualizar el listado");
    console.log(error);
  } finally {
    loading.value = false;
  }
};

watch(
  formState,
  _.debounce(() => handleSearch(), 500)
);
</script>

<style lang="sass" scoped>
.table-users
  margin-top: 12px

header
  display: flex
  justify-content: space-between

.divider
  background-color: $gray-6
</style>
